<mat-form-field #formFieldContainer  class="url-class">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>

  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>

  <input matInput placeholder="{{ componentDefinition?.label }}"
         [id]="elementName + document.documentId" [name]="componentDefinition?.name"
         [readonly]="disabled"
         [formControl]="formControl"
         [errorStateMatcher]="matcher">
  <button type="button" *ngIf="formControl.value" (click)="triggerOpenLink()" type="button" mat-icon-button matSuffix aria-label="open_in_browser" class="ft-url-icon">
    <mat-icon color="primary">open_in_browser</mat-icon>
  </button>

</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
